export class Constants {
  // MOS attribute names
  static readonly MosActionId = "actionId";
  static readonly MosIcons = "icons";
  static readonly MosType = "type";
  static readonly MosV100 = "1.0";
  static readonly MosV101 = "1.1";
  static readonly MosView: string = "view";

  // GA Versions
  static readonly MosManifestGAVersion_1_17 = "1.17";
  static readonly $Schema: string = "$schema";

  // Devpreview schema urls
  static readonly MosManifestSchemaVersionDevPreview =
    "https://developer.microsoft.com/json-schemas/teams/vDevPreview/MicrosoftTeams.schema.json#";
  static readonly MosManifestLocalizationSchemaVersionDevPreview =
    "https://developer.microsoft.com/json-schemas/teams/vDevPreview/MicrosoftTeams.Localization.schema.json#";
  static readonly MosManifestSchemaVersionDevPreviewOld =
    "https://raw.githubusercontent.com/OfficeDev/microsoft-teams-app-schema/preview/DevPreview/MicrosoftTeams.schema.json#";

  // GA schema urls
  static readonly MosManifestSchemaVersionGA =
    "https://developer.microsoft.com/json-schemas/teams/v1.17/MicrosoftTeams.schema.json#";
  static readonly MosManifestLocalizationSchemaVersionGA =
    "https://developer.microsoft.com/json-schemas/teams/v1.17/MicrosoftTeams.Localization.schema.json#";

  // MOS permissions
  static readonly DocumentRestrictedUser = "Document.Restricted.User";
  static readonly DocumentReadAllUser = "Document.ReadAll.User";
  static readonly DocumentReadUser = "Document.Read.User";
  static readonly DocumentReadWriteUser = "Document.ReadWrite.User";
  static readonly DocumentWriteUser = "Document.Write.User";

  static readonly MailboxAccessSharedFoldersUser = "Mailbox.AccessSharedFolders.User";
  static readonly MailboxItemAppendOnSendUser = "MailboxItem.AppendOnSend.User";
  static readonly MailboxItemRestrictedUser = "MailboxItem.Restricted.User";
  static readonly MailboxItemReadUser = "MailboxItem.Read.User";
  static readonly MailboxItemReadWriteUser = "MailboxItem.ReadWrite.User";
  static readonly MailboxReadWriteUser = "Mailbox.ReadWrite.User";

  // Legacy schema and internal property and attribute names
  static readonly InputAction = "action";
  static readonly InputActionId = "actionId";
  static readonly InputAddinCommandsExtensionPoints = "_addinCommandsExtensionPoints";
  static readonly InputAppendOnSend = "AppendOnSend";
  static readonly InputAppointmentOrganizerCommandSurface = "AppointmentOrganizerCommandSurface";
  static readonly InputAppointmentAttendeeCommandSurface = "AppointmentAttendeeCommandSurface";
  static readonly InputAutoRunExtensionPoint = "AutoRunExtensionPoint";
  static readonly InputButton = "Button";
  static readonly InputChildren = "children";
  static readonly InputContextMenuCommandSurface = "ContextMenu";
  static readonly InputContextMenuText = "ContextMenuText";
  static readonly InputContextMenuCell = "ContextMenuCell";
  static readonly InputControl = "control";
  static readonly InputControlType = "controlType";
  static readonly InputDescription = "description";
  static readonly InputDescriptionResId = "descriptionResId";
  static readonly InputDesktopFormFactor = "DesktopFormFactor";
  static readonly InputDesktopSettings = "DesktopSettings";
  static readonly InputDocument = "Document";
  static readonly InputEnabled = "enabled";
  static readonly InputEvents = "events";
  static readonly InputExecuteFunction = "ExecuteFunction";
  static readonly InputFixedControl = "fixedControl";
  static readonly InputFunctionFileResid = "_functionFileResid";
  static readonly InputFunctionName = "functionName";
  static readonly InputGetStartedNode = "_getStartedNode";
  static readonly InputGroup = "group";
  static readonly InputIcon = "icon";
  static readonly InputIconResId = "iconResId";
  static readonly InputId = "id";
  static readonly InputImages = "images";
  static readonly InputLabel = "label";
  static readonly InputLabelResId = "labelResId";
  static readonly InputLaunchEvent = "LaunchEvent";
  static readonly InputLearnMoreUrl = "learnMoreUrl";
  static readonly InputMailHost = "MailHost";
  static readonly InputMeetingDetailsOrganizer = "";
  static readonly InputMenu = "Menu";
  static readonly InputMenuItem = "MenuItem";
  static readonly InputMessageComposeCommandSurface = "MessageComposeCommandSurface";
  static readonly InputMessageReadCommandSurface = "MessageReadCommandSurface";
  static readonly InputMobileAppointmentAttendeeCommandSurface = "MobileAppointmentAttendeeCommandSurface";
  static readonly InputMobileAppointmentOrganizerCommandSurface = "MobileAppointmentOrganizerCommandSurface";
  static readonly InputMobileLogEventAppointmentAttendee = "MobileLogEventAppointmentAttendee";
  static readonly InputMobileMessageComposeCommandSurface = "MobileMessageComposeCommandSurface";
  static readonly InputMobileMessageReadCommandSurface = "MobileMessageReadCommandSurface";
  static readonly InputMobileOnlineMeetingCommandSurface = "MobileOnlineMeetingCommandSurface";
  static readonly InputMobileFormFactor = "MobileFormFactor";
  static readonly InputOptions = "options";
  static readonly InputOverridenByRibbonApi = "overridenByRibbonApi";
  static readonly InputPosition = "position";
  static readonly InputPresentation = "Presentation";
  static readonly InputPrimaryCommandSurface = "PrimaryCommandSurface";
  static readonly InputRequirements = "_requirements";
  static readonly InputReportPhishingCommandSurface = "ReportPhishingCommandSurface";
  static readonly InputResid = "resid";
  static readonly InputScale = "scale";
  static readonly InputSendMode = "sendMode";
  static readonly InputSendModeBlock = "block";
  static readonly InputSendModePromptUser = "promptuser";
  static readonly InputSendModeSoftBlock = "softblock";
  static readonly InputSets = "sets";
  static readonly InputSize = "size";
  static readonly InputShowTaskpane = "ShowTaskpane";
  static readonly InputSourceLocation = "sourceLocation";
  static readonly InputSourceLocationResid = "sourceLocationResid";
  static readonly InputSpamFreeTextSectionLabelResId = "spamFreeTextSectionLabelResId";
  static readonly InputSpamMoreInfo = "spamMoreInfo";
  static readonly InputSpamPreProcessingDialog = "spamPreProcessingDialog";
  static readonly InputSpamReportingOptions = "spamReportingOptions";
  static readonly InputSupertip = "superTip";
  // This is currently not used but is here for completeness for translation from OSF.FormFactor which has a OSF.FormFactor.Tablet
  // in _InputFormFactorFromOSFFormFactor.
  static readonly InputTabletFormFactor = "TabletFormFactor";
  static readonly InputTabs = "tabs";
  static readonly InputTaskpaneId = "taskpaneId";
  static readonly InputTextResId = "textResId";
  static readonly InputPinnable = "pinnable";
  static readonly InputTitle = "title";
  static readonly InputTitleResId = "titleResId";
  static readonly InputType = "type";
  static readonly InputUrlResId = "urlResId";
  static readonly InputWorkbook = "Workbook";
  static readonly InputMailBoxCapability = "Mailbox";
  static readonly InputAddinCommandCapability = "AddinCommands";

  // Legacy manifest constants
  static readonly LegacyMailAppIconSize: number = 64;
  static readonly LegacyWXPAppIconSize: number = 32;
  static readonly LegacyMailAppHighResolutionIconSize: number = 128;
  static readonly LegacyWXPAppHighResolutionIconSize: number = 64;

  // Mos manifest Localized resources
  static readonly DeveloperPrivacyUrl: string = "developer.privacyUrl";
  static readonly DeveloperTermsOfUseUrl: string = "developer.termsOfUseUrl";
  static readonly DeveloperWebSiteUrl: string = "developer.websiteUrl";
  static readonly ExtensionAudienceClaimUrl: string = "extensions[0].audienceClaimUrl";
  static readonly IconsColor: string = "icons.color";
  static readonly IconsOutline: string = "icons.outline";
  static readonly MosDescriptionFull: string = "description.full";
  static readonly MosDescriptionShort: string = "description.short";
  static readonly MosCode: string = "code";
  static readonly MosId: string = "id";
  static readonly MosNameFull: string = "name.full";
  static readonly MosNameShort: string = "name.short";
  static readonly MosRequirements: string = "requirements";

  static readonly AlternatesHighResolutionIconUrl: string =
    "extensions[0].alternates[%d].alternateIcons.highResolutionIcon.url";
  static readonly AlternatesIconUrl: string = "extensions[0].alternates[%d].alternateIcons.icon.url";

  // Spam processing fixed control resource strings
  static readonly RibbonsFixedControlsLabel: string = "extensions[0].ribbons[%d].fixedControls[%d].label";
  static readonly RibbonsFixedControlsIconsUrl: string = "extensions[0].ribbons[%d].fixedControls[%d].icons[%d].url";
  static readonly RibbonsFixedControlsSuperTipDescription: string = "extensions[0].ribbons[%d].fixedControls[%d].supertip.description";
  static readonly RibbonsFixedControlsSuperTipTitle: string = "extensions[0].ribbons[%d].fixedControls[%d].supertip.title";

  // Spam processing dialog related resource strings
  static readonly RibbonsSpamProcessingDialogDescription: string = "extensions[0].ribbons[%d].spamPreProcessingDialog.description";
  static readonly RibbonsSpamProcessingDialogSpamFreeTextSectionLabel: string = "extensions[0].ribbons[%d].spamPreProcessingDialog.spamFreeTextSectionLabel";
  static readonly RibbonsSpamProcessingDialogTitle: string = "extensions[0].ribbons[%d].spamPreProcessingDialog.title";
  static readonly RibbonsSpamProcessingDialogSpamMoreInfoText: string = "extensions[0].ribbons[%d].spamPreProcessingDialog.spamMoreInfo.text";
  static readonly RibbonsSpamProcessingDialogSpamMoreInfoUrl: string = "extensions[0].ribbons[%d].spamPreProcessingDialog.spamMoreInfo.url";
  static readonly RibbonsSpamProcessingDialogSpamReportingOptionsTitle: string = "extensions[0].ribbons[%d].spamPreProcessingDialog.spamReportingOptions.title";
  static readonly RibbonsSpamProcessingDialogSpamReportingOptionsOptions: string = "extensions[0].ribbons[%d].spamPreProcessingDialog.spamReportingOptions.options[%d]";
  
  static readonly RibbonsTabsLabel: string = "extensions[0].ribbons[%d].tabs[%d].label";
  static readonly RibbonsTabsCustomMobileRibbonGroupsLabel: string =
    "extensions[0].ribbons[%d].tabs[%d].customMobileRibbonGroups[%d].label";
  static readonly RibbonsTabsCustomMobileRibbonGroupsControlsLabel: string =
    "extensions[0].ribbons[%d].tabs[%d].customMobileRibbonGroups[%d].controls[%d].label";
  static readonly RibbonsTabsCustomMobileRibbonGroupsControlsIconsUrl: string =
    "extensions[0].ribbons[%d].tabs[%d].customMobileRibbonGroups[%d].controls[%d].icons[%d].url";
  static readonly RibbonsTabsGroupsIconsFile: string = "extensions[0].ribbons[%d].tabs[%d].groups[%d].icons[%d].file";
  static readonly RibbonsTabsGroupsIconsUrl: string = "extensions[0].ribbons[%d].tabs[%d].groups[%d].icons[%d].url";
  static readonly RibbonsTabsGroupsLabel: string = "extensions[0].ribbons[%d].tabs[%d].groups[%d].label";
  static readonly RibbonsTabsGroupsControlsIconsFile: string =
    "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].icons[%d].file";
  static readonly RibbonsTabsGroupsControlsIconsUrl: string =
    "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].icons[%d].url";
  static readonly RibbonsTabsGroupsControlsLabel: string =
    "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].label";
  static readonly RibbonsTabsGroupsControlsSupertipTitle: string =
    "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].supertip.title";
  static readonly RibbonsTabsGroupsControlsSupertipDescription: string =
    "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].supertip.description";
  static readonly RibbonsTabsGroupsControlsItemsIconsFile: string =
    "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].items[%d].icons[%d].file";
  static readonly RibbonsTabsGroupsControlsItemsIconsUrl: string =
    "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].items[%d].icons[%d].url";
  static readonly RibbonsTabsGroupsControlsItemsLabel: string =
    "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].items[%d].label";
  static readonly RibbonsTabsGroupsControlsItemsSupertipTitle: string =
    "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].items[%d].supertip.title";
  static readonly RibbonsTabsGroupsControlsItemsSupertipDescription: string =
    "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].items[%d].supertip.description";

  static readonly ContextMenusMenusControlsIconsFile: string =
    "extensions[0].contextMenus[%d].menus[%d].controls[%d].icons[%d].file";
  static readonly ContextMenusMenusControlsIconsUrl: string =
    "extensions[0].contextMenus[%d].menus[%d].controls[%d].icons[%d].url";
  static readonly ContextMenusMenusControlsLabel: string =
    "extensions[0].contextMenus[%d].menus[%d].controls[%d].label";
  static readonly ContextMenusMenusControlsSupertipTitle: string =
    "extensions[0].contextMenus[%d].menus[%d].controls[%d].supertip.title";
  static readonly ContextMenusMenusControlsSupertipDescription: string =
    "extensions[0].contextMenus[%d].menus[%d].controls[%d].supertip.description";

  static readonly ContextMenusMenusControlsItemsIconsFile: string =
    "extensions[0].contextMenus[%d].menus[%d].controls[%d].items[%d].icons[%d].file";
  static readonly ContextMenusMenusControlsItemsIconsUrl: string =
    "extensions[0].contextMenus[%d].menus[%d].controls[%d].items[%d].icons[%d].url";
  static readonly ContextMenusMenusControlsItemsLabel: string =
    "extensions[0].contextMenus[%d].menus[%d].controls[%d].items[%d].label";
  static readonly ContextMenusMenusControlsItemsSupertipTitle: string =
    "extensions[0].contextMenus[%d].menus[%d].controls[%d].items[%d].supertip.title";
  static readonly ContextMenusMenusControlsItemsSupertipDescription: string =
    "extensions[0].contextMenus[%d].menus[%d].controls[%d].items[%d].supertip.description";

  static readonly ContentRuntimesPage: string = "extensions[0].contentRuntimes[%d].code.page";
  static readonly RuntimesPage: string = "extensions[0].runtimes[%d].code.page";
  static readonly RuntimesScript: string = "extensions[0].runtimes[%d].code.script";
  static readonly RuntimesActionsDisplayName: string = "extensions[0].runtimes[%d].actions[%d].displayName";

  // Default and predetermined values
  static readonly DefaultAccessColor: string = "#230201";
  static readonly DefaultDeveloperUrl: string = "http://localhost/";
  static readonly InvalidCharacterInFileName = /[/\\?*:|"<>]/g;
  static readonly RuntimeLifetimeShort: string = "short";
  static readonly RuntimeLifetimeLong: string = "long";

  // Other constants
  static readonly DefaultOutputFolderName: string = "temp";
  static readonly EllipsisText: string = "...";
  static readonly JSONFileSuffix: string = ".json";
  static readonly JSONManifestFileName: string = "manifest.json";
  static readonly LoggingPrefix: string = "[CONVERTER]: ";
  static readonly LoggingPrefixWarning: string = "[CONVERTER]: WARNING: ";
  static readonly LoggingPrefixError: string = "[CONVERTER]: ERROR: ";
  static readonly MaxResourceStringLengthAny: number = -1;
  static readonly MaxResourceStringLength30: number = 30;
  static readonly MaxResourceStringLength32: number = 32;
  static readonly MaxResourceStringLength64: number = 64;
  static readonly MaxResourceStringLength80: number = 80;
  static readonly MaxResourceStringLength100: number = 100;
  static readonly MaxResourceStringLength128: number = 128;
  static readonly MaxResourceStringLength250: number = 250;
  static readonly MaxResourceStringLength256: number = 256;
  static readonly MaxResourceStringLength512: number = 512;
  static readonly MaxResourceStringLength2048: number = 2048;
  static readonly MaxResourceStringLength4000: number = 4000;
  static readonly TruncationText: string = "<TRUNCATED>";
}
